var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"datetime"},[_c('Time',{attrs:{"date":_vm.date},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var time = ref.time;
return [_vm._t("default",[_vm._v(" "+_vm._s(_vm.dateFormatted)+" "+_vm._s(time)+" ")],{"datetime":(_vm.date + " " + time)})]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }